import React, { useEffect, useState } from 'react'
import { switchLanguageAndReload } from "../../../commons/Utils/LanguageSwitcher";

export default function HeaderMenuLoggedIn ({ user, locale, dana }) {
  const [usernameLink, setUsernameLink] = useState('')

  useEffect(() => {

    if (user.has_awaiting_payments) {
      const optionLinkBadgeContainer = document.getElementsByClassName('option__link-badge')
      if (optionLinkBadgeContainer.length > 0) {
        optionLinkBadgeContainer[0].classList.add('option__link-badge--awaiting-payments');
      }
    }
    setUsernameLink(`/@${user.username}`)

  },[])

  function handleSwitchLanguage(event, langCode) {
    event.preventDefault();
    switchLanguageAndReload(langCode);
  }

  return (
    <div className="header-login">
      {
        !user.has_active_subscription &&
        <a href="/packages" className="header-login__subscribe button-primary button-s">
          {locale.subscribe}
        </a>
      }
      <div className="header-login__options header-login__options--logged-in">
        <div className="header-login__more">
          <div className="header-login__user-info">
            <div className="option-user__avatar">
              <picture>
                <source srcSet={user.avatar_url} type='image/webp'/>
                <img src={user.avatar_url}
                  data-title={user.display_name}
                  alt={user.display_name}
                  height='32'
                  width='32'
                  srcSet={user.avatar_url}
                />
              </picture>
            </div>
            <div className="option-user__title">
              {user.username}
            </div>
            <span className="caret-close" />
          </div>
        </div>
        <input type="checkbox" id="options" className="hidden" />
        <div className="header-login__menu header-login__menu--logged-in">
          <div className="option">
            <input type="checkbox" id="option-premier" className="hidden" />
            <input type="checkbox" id="option-library" className="hidden" />
            <input type="checkbox" id="option-setting" className="hidden" />
            <input type="checkbox" id="option-lang" className="hidden" />
            <ul className="option__side" data-input-from="option-premier">
              <li>
                <label htmlFor="option-premier" className="header-login__more">
                  <div className="option__title item back">
                    {locale.profile_menu.subscriptions_and_purchases}
                  </div>
                </label>
              </li>
              <li><hr/></li>
              <li>
                  <a href="/dashboard/transaction/histories"
                  className="option__link option__link-badge">
                  {locale.profile_menu.active_packages}
                  </a>
              </li>
              <li>
                <a href="/promo"
                  className="option__link js-link__promo-voucher js-ahoy"
                  data-ahoy-props='{"action":"click","feature":"voucher promotion"}'
                  data-ahoy-click="true"
                  data-ahoy-title="SUBSCRIPTION"
                >
                  { locale.profile_menu.promo_voucher }
                </a>
              </li>
              <li>
                <a href="/redeem" className="option__link">
                  {locale.profile_menu.redeem_voucher}
                </a>
              </li>
            </ul>
            <ul className="option__side" data-input-from="option-library">
              <li>
                <label htmlFor="option-library" className="header-login__more">
                  <div className="option__title item back">
                    {locale.profile_menu.my_library}
                  </div>
                </label>
              </li>
              <li><hr /></li>
              <li>
                <a href="/my-list" className="option__link">
                  {locale.profile_menu.my_list}
                </a>
              </li>
              <li>
                <a href="/purchased" className="option__link">
                  {locale.profile_menu.purchased}
                </a>
              </li>
              <li>
                <a href="/dashboard/feeds" className="option__link">
                  {locale.following}
                </a>
              </li>
              <li>
                <a href="/dashboard/histories" className="option__link">
                  {locale.profile_menu.watch_history}
                </a>
              </li>
            </ul>
            <ul className="option__side" data-input-from="option-setting">
              <li>
                <label htmlFor="option-setting" className="header-login__more">
                  <div className="option__title item back">
                    {locale.profile_menu.help_and_others}
                  </div>
                </label>
              </li>
              <li><hr /></li>
              <li>
                <a href="https://support.vidio.com" className="option__link">
                  {locale.login_menu.help}
                </a>
              </li>
              <li>
                <a href="/pages/terms-and-conditions" className="option__link">
                  {locale.login_menu.terms}
                </a>
              </li>
              <li>
                <a href="https://careers.vidio.com" className="option__link" rel="noopener">
                  {locale.login_menu.careers}
                </a>
              </li>
              <li><hr /></li>
              <li>
              <label htmlFor="option-lang" className="header-login__more">
                <div className="item forward">
                  {locale.login_menu.language}
                </div>
              </label>
              </li>
            </ul>
            <ul className="option__side" data-input-from="option-lang">
              <li>
                <label htmlFor="option-lang" className="header-login__more">
                  <div className="option__title item back">
                    {locale.login_menu.language}
                  </div>
                </label>
              </li>
              <li><hr /></li>
              <li>
                <a onClick={(e) => {handleSwitchLanguage(e, "id")}} className="option__link" href="#">
                  Indonesia
                </a>
              </li>
              <li>
                <a onClick={(e) => {handleSwitchLanguage(e, "en")}} className="option__link" href="#">
                  English
                </a>
              </li>
            </ul>
            <ul className="option__base" role="presentation">
              <li>
                <div className="option-user">
                  <div className="option-user__avatar">
                  <picture>
                    <source srcSet={user.avatar_url} type='image/webp'/>
                    <img src={user.avatar_url}
                      data-title={user.display_name}
                      alt={user.display_name}
                      height='32'
                      width='32'
                      srcSet={user.avatar_url}
                    />
                  </picture>
                  </div>
                    <div className="option-user__desc">
                      <a href={usernameLink}>
                        <h4>{user.username}</h4>
                        <p>{user.display_name}</p>
                      </a>
                    </div>
                    <div className="option-user__button">
                      <a href="/dashboard/videos/new">
                        <div className="knob knob--upload"/>
                      </a>
                    </div>
                </div>
              </li>
              <li>
                <a href="/dashboard/dana_accounts" className="option__dana-button">
                  <span className="option__dana-icon" />
                  <div className="option__dana-balance">
                    { dana.bind ?
                      locale.profile_menu.dana_balance
                      :
                      locale.profile_menu.dana_activation
                    }
                  </div>
                </a>
              </li>
              <li>
                <div className="option__kids-mode-wrapper">
                  <div className="option__kids-mode-icon"/>
                  <div className="option__kids-mode-title">
                    {locale.login_menu.kids_mode_title}
                  </div>
                  <label className="option__kids-mode-toggle">
                    <input type='checkbox' id='kids-mode' />
                    <span className="option__kids-mode-slider option__kids-mode-toggle-button"/>
                  </label>
                </div>
              </li>
              { user.officer &&
              <li className="spec__profile-menu-authorized__admin">
                <a href="/dashboard/menu" className="option__link">
                  {locale.profile_menu.admin}
                </a>
              </li>
              // <li><hr/></li>
              }
              <li>
                <label htmlFor="option-premier" className="header-login__more">
                  <div className="item forward">
                    {locale.profile_menu.subscriptions_and_purchases}
                  </div>
                </label>
              </li>
              <li>
                <label htmlFor="option-library" className="header-login__more">
                  <div className="item forward">
                    {locale.profile_menu.my_library}
                  </div>
                </label>
              </li>
              <li>
                <a href="/dashboard" className="option__link">
                  {locale.profile_menu.dashboard}
                </a>
              </li>
              <li>
                <a href="/dashboard/setting" className="option__link">
                  {locale.profile_menu.account_setting}
                </a>
              </li>
              <li><hr /></li>
              <li>
                <a href="/tv" className="option__link">
                  {locale.profile_menu.login_tv}
                </a>
              </li>
              <li>
                <a href="/referral" className="option__link">
                  {locale.profile_menu.referral_voucher}
                </a>
              </li>
              <li>
                <label htmlFor="option-setting" className="header-login__more">
                  <div className="item forward">
                    {locale.profile_menu.help_and_others}
                  </div>
                </label>
              </li>
              <li>
                <a href="https://about.vidio.com" className="option__link">
                  Blog
                </a>
              </li>
              <li><hr /></li>
              <li>
                <a href="/users/logout"
                  className="option__link option__link js-link__logout js-ahoy"
                  data-ahoy-props='{"action" : "logout", "referrer": "#{document.referrer}", "page": "#{location.href}"}'
                  data-ahoy-click="true"
                  data-ahoy-title="LOGOUT"
                  data-method="delete"
                >
                  {locale.profile_menu.logout}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}
